module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bottle1-74a0f66d1c797d8230af5fa4ae985774.svg";